import { FETCH_BOTS_SUCCESS, FETCH_FLOWS_SUCCESS } from 'Src/actions/bots'

const initialState = {
  bots: [],
  flows: {
    // [botId]: [ ...flows ]
  }
}

const dashboard = (state = initialState, action) => {
  const payload = action.payload

  switch (action.type) {
    case FETCH_BOTS_SUCCESS:
      return {
        ...state,
        bots: payload
      }

    case FETCH_FLOWS_SUCCESS: {
      const { botId, flows } = payload

      return {
        ...state,
        flows: {
          ...state,
          [botId]: flows
        }
      }
    }

    default:
      return state
  }
}

export default dashboard
